import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';

const AccordionDetails = withStyles((theme: Theme) => {
  return {
    root: {
      padding: theme.spacing(0, 2, 3, 0),
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(-1),
        padding: theme.spacing(0, 2, 1, 0),
      },
    },
  };
})(MuiAccordionDetails);
export default AccordionDetails;
